import React, { useRef, useState } from 'react'
import { PopupModal } from '../../../Modals/Index';
import FilterVintageIcon from '@material-ui/icons/FilterVintage';
import ViewArrayIcon from '@material-ui/icons/ViewArray';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import FlareIcon from '@material-ui/icons/Flare';
import PrintIcon from '@material-ui/icons/Print';
import TShirt from '../../../Assets/Photos/tshirt.png';
import deleteIcon from '../../../Assets/Photos/deleteIcon.png';
import logoDesgin from '../../../Assets/Photos/logoDesgin.png';
import vc from '../../../Assets/Photos/vc.png';
import hc from '../../../Assets/Photos/hc.png';
import rs from '../../../Assets/Photos/rs.png';
import ls from '../../../Assets/Photos/ls.png';
import ts from '../../../Assets/Photos/ts.png';
import bs from '../../../Assets/Photos/bs.png';
import ImageIcon from '@material-ui/icons/Image';

import "./PrintMockup.css";
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
const colors = [
    "rgba(0, 0, 0, 1)",
    "rgba(53, 53, 53, 1)",
    "rgba(255, 179, 0, 1)",
    "rgba(255, 207, 231, 1)",
    "rgba(175, 175, 175, 1)",
    "rgba(3, 45, 73, 1)",
    "rgba(25, 61, 36, 1)",
    "rgba(206, 5, 31, 1)",
    "rgba(16, 28, 134, 1)",
    "rgba(27, 206, 250, 1)"
];

const heightMult = 200 / 15.7;
const widthMult = 150 / 15.7;

const PrintMockup = ({ state, setStateFalse }) => {
    const [height, setHeight] = useState(15.7);
    const [width, setWidth] = useState(15.7);
    const [left, setLeft] = useState(7.85);
    const [top, setTop] = useState(7.85);
    const inputRef = useRef();
    const [url, setUrl] = useState(null);
    const [name, setName] = useState('');

    const onChange = e => {
        const objectUrl = URL.createObjectURL(e.target.files[0])
        setName(e.target.files[0].name);
        setUrl(objectUrl);
    };

    console.log(url);

    return (
        <PopupModal setStateFalse={setStateFalse} state={state}>
            <div className="popupConatiner">
                <div className="home_head">
                    <h2 className="home_heading">Mockup</h2>
                </div>
                <div className="popup_body">
                    <div className="big_icons_container">
                        <div className='details-container'>
                            <h2 className="home_heading">Men’s Clothing</h2>
                            <h1 className='home-sub-product-heading'><span>Half Sleeve</span> Round Neck T-Shirt</h1>
                            <p className='info-heading'>Maximum print area (W x H) - 15.6 in x 19.6 in</p>
                            <h3 className='home-item-heading'>
                                Color:
                            </h3>
                            <div className='color-palet-container'>
                                {colors.map(ele => <ColorPalet key={ele} color={ele} />)}
                            </div>
                            <h3 className='home-item-heading'>
                                Size:
                            </h3>
                            <div className='color-palet-container'>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        XS
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        S
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        M
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        L
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        XL
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        2XL
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        3XL
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        4XL
                                    </p>
                                </td>
                                <td className="product_description_table_body_data min-width">
                                    <p className="product_description_table_body_data_size">
                                        5XL
                                    </p>
                                </td>
                            </div>
                            <p className='status-stock'>In-Stock</p>
                            <div className="payment_details_payment_type">
                                <RadioGroup defaultValue={"male"} aria-label="payemntType" name="payemntType">
                                    <FormControlLabel value="male" control={<Radio />} label="Plain" />
                                    <FormControlLabel value="female" control={<Radio />} label="Printed" />
                                </RadioGroup>
                            </div>
                            <div className='preview-current-logo'>
                                <div className='preview-current-logo-details'>
                                    {url && <img src={url} alt={name} height={100} width={100} />}
                                    {url ? <p>{name}</p> : <p>No Image to Preview</p>}
                                </div>
                                <img onClick={() => { setUrl(null) }} src={deleteIcon} style={{ cursor: 'pointer' }} alt="deleteIcon" height={24} />
                            </div>
                            <div className='preview-size-variant'>
                                <h3 style={{ minWidth: '110px' }} className='home-item-heading'>
                                    Size
                                </h3>
                                <CustomInput value={width} change={(val) => setWidth(val)} name="Width" unit="In" />
                                <CustomInput value={height} change={(val) => setHeight(val)} name="Height" unit="In" />
                            </div>
                            <div className='preview-size-variant'>
                                <h3 style={{ minWidth: '110px' }} className='home-item-heading'>
                                    Position
                                </h3>
                                <CustomInput value={left} change={(val) => setLeft(val)} name="Top" unit="In" />
                                <CustomInput value={top} change={(val) => setTop(val)} name="Left" unit="In" />
                            </div>
                            <div className='preview-size-variant'>
                                <h3 style={{ minWidth: '110px' }} className='home-item-heading'>
                                    Alignment
                                </h3>
                                <IconAlignment click={() => { setTop(7.75); }} imgsrc={vc} />
                                <IconAlignment click={() => { setLeft(7.75); }} imgsrc={hc} />
                                <IconAlignment click={() => { setLeft(15.7) }} imgsrc={rs} />
                                <IconAlignment click={() => { setLeft(0) }} imgsrc={ls} />
                                <IconAlignment click={() => { setTop(0) }} imgsrc={ts} />
                                <IconAlignment click={() => { setTop(15.7); }} imgsrc={bs} />
                            </div>
                        </div>
                        <div className='product-sample'>
                            <div className='product-sample-display'>
                                <p className='active'>Front</p>
                                <p>Back</p>
                                <p>Sleeve</p>
                            </div>
                            <div className='product-sample-contianer'>
                                <img src={TShirt} width={400} height={421} />
                                <div style={{
                                    width: width * widthMult,
                                    height: height * heightMult,
                                    left: `${((left) / 15.7) * 100}%`,
                                    top: `${((top) / 15.7) * 100}%`
                                }} className='product-sample-logo'>
                                    <img alt={name} src={url} style={{ backgroundSize: 'cover', width: '100%', height: '100%' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='popup-footer'>
                    <label
                        onClick={() => {
                            inputRef.current.click();
                        }}
                        htmlFor="upload-image-input-libaray"
                    >
                        <input
                            ref={inputRef}
                            id="upload-image-input-libaray"
                            type="file"
                            multiple={false}
                            accept="image/*"
                            name="upload-image-input-libaray"
                            className="upload-image-hide"
                            onChange={onChange}
                        />
                        <button className="btn-orange">
                            <ImageIcon className="btn-icon" />
                            <p>Upload Your Image</p>
                        </button>
                    </label>
                    <div className="footer_button">
                        <button style={{ marginRight: '2rem' }} onClick={setStateFalse} className="btn-gray">
                            <KeyboardBackspaceIcon className="btn-icon " />
                            <p>Back</p>
                        </button>
                        <button
                            onClick={() => {
                                setStateFalse();
                            }}
                            className="btn-orange "
                        >
                            <p>Proceed</p>
                        </button>
                    </div>
                </div>
            </div>
        </PopupModal>
    )
};

const ColorPalet = ({ color }) => {
    return <div style={{ backgroundColor: `${color}` }} className='color-palet'>
    </div>
};

const CustomInput = ({ name, unit, value, change }) => {
    return <div className='custom-input-preview'>
        <input type={'number'} value={value} onChange={(e) => { if (e.target.value < 15.7) { change(e.target.value) } }} step={0.1} />
        <p>{name}</p>
        <p>{unit}</p>
    </div>
};

const IconAlignment = ({ imgsrc, click }) => {
    return <img onClick={click} className='icon-alignment-image' src={imgsrc} />
}

export default PrintMockup